const formatLink = (link: string) => link && link.trim().length > 0 && !link.includes("http://") && !link.includes("https://") ? `https://${link}` : link;

export default formatLink;
